import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type MascotPanelSide = 'left' | 'right';

interface SettingsState {
  // 天気設定
  weatherEnabled: boolean;

  // マスコットのサイドパネルを空ちゃんのどちら側に出すか
  mascotPanelSide: MascotPanelSide;

  // マスコットのひとりごと（ランダムトーク）
  mascotRandomTalk: boolean;

  // Actions
  setWeatherEnabled: (enabled: boolean) => void;
  setMascotPanelSide: (side: MascotPanelSide) => void;
  setMascotRandomTalk: (enabled: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      // デフォルトはオフ
      weatherEnabled: false,
      mascotPanelSide: 'left',
      mascotRandomTalk: true,

      // Actions
      setWeatherEnabled: (enabled) => set({ weatherEnabled: enabled }),
      setMascotPanelSide: (side) => set({ mascotPanelSide: side }),
      setMascotRandomTalk: (enabled) => set({ mascotRandomTalk: enabled }),
    }),
    {
      name: 'sorarium-settings',
      partialize: (state) => ({
        weatherEnabled: state.weatherEnabled,
        mascotPanelSide: state.mascotPanelSide,
        mascotRandomTalk: state.mascotRandomTalk,
      }),
    }
  )
);
